import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { PageToPageBlock } from '../../_blocks/PageToPage';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type PageToPageWidget = ContextWidget<PageToPageBlock, WidgetType.pageToPage>;

export function PageToPageWidget(props: PageToPageWidget) {
  const { t } = useSonTranslation('PageToPage');
  return <DefaultContextWidget icon={Icons.CONNECTIONS} title={t('widgetTitle.pageToPage')} {...props} />;
}
